<div *ngIf="isLoaderRequired && shouldShowLoader" class="loader" id="loader">
        Loading...
</div>
<div id="platform" style="width: inherit; height: inherit;" [ngStyle]="{
    'overflow': isFloorPlanAvailable === true ? 'hidden': 'scroll',
    'padding': isFloorPlanAvailable === true || view === 'parking-view' ? '0px': '0px',
    'background-color': view === 'parking-view' ? '#F5F5F5': ''
}">
        <ng-container *ngIf="isFloorPlanAvailable === true">
            <pinch-zoom zoomControlScale="3.5" minScale=1 overflow="visible" disableZoomControl="disable" limit-zoom=50
                [eventHandler]="scrollHandler" backgroundColor="rgb(250, 251, 251)" #myPinch>
                <app-plan-builder (isRendered)="isPlanRendered($event)" (mouseEvent)="handleMouseEvent($event)" [FLOOR_DATA]="FLOOR_DATA"
                    [layout]="layout" [isFloorPlanAvailable]="isFloorPlanAvailable" [preRenderedPlan]="preRenderedPlan" [seatID]="seatID" [empGuid]="empGuid"></app-plan-builder>
            </pinch-zoom>
        </ng-container>
        <app-booking-details-holder *ngIf="shouldDisplayBookingPopUp" (closeEmitter)="dismissPopUp($event)" [selectedSearchSeat]="selectedSearchSeat" [seatStatus]="seatStatus" [selectedSearchInfo]="selectedSearchInfo"  [openedFrom]="openedFrom"
            [timeZone]="timeZone" [popUpPosition]="popUpPosition" [bookingData]="bookingDisplayData" [bookingDisplaySeat]="bookingDisplaySeat" [bookingPopUpDirection]="bookingPopUpDirection" [isSeatClicked]="isSeatClicked" ></app-booking-details-holder>
        <lib-team-tool-tip *ngIf="showTeamTooltip" (TeamcloseEmitter)="teamDismissPopUp($event)"
             [teamPopUpPosition]="teamPopUpPosition" [teamPopUpDirection]="teamPopUpDirection" [teamDisplayText]="teamDisplayText"></lib-team-tool-tip>
        <section id="gridSeatView" class="layout-nofloorplan" *ngIf="isFloorPlanAvailable === false"
             [ngStyle]="{
                'background': view === 'parking-view'? 'none': '',
                'padding': view === 'parking-view'? '0px': ''
                }"
            [ngClass]="{'expandedCSS': (expanded && (view == 'admin-view' || view == 'assignment-view' || view == 'sanitisation-view')), 'collapsedCSS': (!expanded && (view == 'admin-view' || view == 'assignment-view'))}">
            <p class="grid-heading" *ngIf="view == 'employee-view' && teamSeatsArr.length > 0">Your Team</p>
            <div class="floor-nofloorplan" *ngIf="view == 'employee-view'">
                <ng-container *ngFor="let seat of teamSeatsArr; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                        <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                            <span class="rect-seat rect-seat-selected">
                                {{seat.properties.name}}
                            </span>
                        </div>
                        <ng-template #selectable>
                            <div class="rectangle">
                                <span class="rect-seat"
                                    [ngClass]="{'rect-seat-available': seat.properties.status === 'AVAILABLE', 'rect-seat-na': seat.properties.status === 'Not Available', 'rect-seat-booked': seat.properties.status === 'BOOKED'}">
                                    {{seat.properties.name}}
                                </span>
                                <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                    src="assets/occupied-circle.svg" />
                            </div>
                        </ng-template>
                        <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id) "
                            [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                            [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-booked-employee-details>
                    </div>
                </ng-container>
            </div>
            <p *ngIf="teamSeatsArr.length === 0 && view == 'employee-view'">No seat available</p>
            <p class="grid-heading" *ngIf="view == 'employee-view'">Hot Seats</p>
            <div class="floor-nofloorplan" *ngIf="view == 'employee-view' && hotSeatsArr.length > 0">
                <ng-container *ngFor="let seat of hotSeatsArr; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                        <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                            <span class="rect-seat rect-seat-selected">
                                {{seat.properties.name}}
                            </span>
                        </div>
                        <ng-template #selectable>
                            <div class="rectangle">
                                <span class="rect-seat"
                                    [ngClass]="{'hot-seat-available': seat.properties.status === 'AVAILABLE', 'hot-seat-na': seat.properties.status === 'Not Available', 'hot-seat-booked': seat.properties.status === 'BOOKED'}">
                                    {{seat.properties.name}}
                                </span>
                                <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                    src="assets/occupied-circle.svg" />
                            </div>
                        </ng-template>
                        <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.properties.ID) "
                            [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                            [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-booked-employee-details>
                        <app-searched-employee-details *ngIf="showSearchedEmployeeDetail && (showSearchedEmployee === seat.properties.ID)"
                            [initialZoom]="employeeDetailCardScale" [details]="searchedEmployeeBookings[0]"
                            [seatName]="layout.floorSeatsDTOMap[seat.id].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-searched-employee-details>
                    </div>
                </ng-container>
            </div>
            <p *ngIf="hotSeatsArr.length === 0 && view == 'employee-view'">Hot Seats are not available</p>
            <p class="grid-heading" *ngIf="view == 'employee-view'">Other Seats</p>
            <div class="floor-nofloorplan" *ngIf="view == 'employee-view' && otherSeatsArr.length > 0">
                <ng-container *ngFor="let seat of otherSeatsArr; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                        <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                            <span class="rect-seat rect-seat-selected">
                                {{seat.properties.name}}
                            </span>
                        </div>
                        <ng-template #selectable>
                            <div class="rectangle">
                                <span class="rect-seat"
                                    [ngClass]="{'rect-seat-available': seat.properties.status === 'AVAILABLE', 'rect-seat-na': seat.properties.status === 'Not Available', 'rect-seat-booked': seat.properties.status === 'BOOKED'}">
                                    {{seat.properties.name}}
                                </span>
                                <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                    src="assets/occupied-circle.svg" />
                            </div>
                        </ng-template>
                        <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id)"
                            [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                            [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-booked-employee-details>
                        <app-searched-employee-details *ngIf="showSearchedEmployeeDetail && (showSearchedEmployee === seat.id)"
                            [initialZoom]="employeeDetailCardScale" [details]="searchedEmployeeBookings[0]"
                            [seatName]="layout.floorSeatsDTOMap[seat.id].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-searched-employee-details>
                    </div>
                </ng-container>
            </div>
            <p *ngIf="otherSeatsArr.length === 0 && view == 'employee-view'">No seats available</p>
            <div class="floor-nofloorplan" *ngIf="view == 'admin-view'">
                <ng-container *ngFor="let seat of seats; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                        <div class="rectangle">
                            <span *ngIf="seat.properties.status === 'AVAILABLE'; else rectNonAvlSeat" class="rect-seat"
                                style="border:1px solid;" [ngStyle]="{'border': '1px solid '+getGridSeatColor(seat)}">
                                {{seat.properties.name}}
                            </span>
                            <ng-template #rectNonAvlSeat>
                                <span class="rect-seat" [ngStyle]="{'background-color': getGridSeatColor(seat)}">
                                    {{seat.properties.name}}
                                </span>
                            </ng-template>
                            <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')" src="assets/occupied-circle.svg" />
                            <!-- <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id)"
                                [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                                [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-booked-employee-details>
                            <app-searched-employee-details
                                *ngIf="showSearchedEmployeeDetail && (showSearchedEmployee === seat.id)"
                                [initialZoom]="employeeDetailCardScale" [details]="searchedEmployeeBookings[0]"
                                [seatName]="layout.floorSeatsDTOMap[seat.id].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-searched-employee-details> -->
                        </div>
                    </div>
                </ng-container>
            </div>
        
            <div class="floor-nofloorplan" *ngIf=" view == 'assignment-view'">
                <ng-container *ngFor="let seat of seats; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                        <div class="rectangle" *ngIf="checkArrayContainsSeatId(seat.properties.ID); else selectable">
                            <span class="rect-seat rect-seat-selected">
                                {{seat.properties.name}}
                            </span>
                        </div>
                        <ng-template #selectable>
                            <div class="rectangle">
                                <span class="rect-seat" [ngStyle]="{'background-color': getGridSeatColor(seat)}">
                                    {{seat.properties.name}}
                                </span>
                            </div>
                        </ng-template>
                        <!-- <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id)"
                            [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                            [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                            (onClose)="closeEmployeeDetail($event)">
                        </app-booked-employee-details> -->
                    </div>
                </ng-container>
            </div>
        
        
            <div class="floor-nofloorplan" *ngIf=" view == 'sanitisation-view'">
                <ng-container *ngFor="let seat of seats; let i=index;">
                    <!-- TODO map seat selected color -->
                    <div class="seat-nofloorplan" title="{{seat.properties.name}}">
                        <div class="rectangle">
                            <span class="rect-seat"
                                [ngClass]="{'rect-seat-sanitisation-needed':!seat.isSanitized, 'rect-seat-sanitisation-not-needed':seat.isSanitized}">
                                {{seat.properties.name}}
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="floor-nofloorplan" *ngIf="view === 'preferences-view'">
                <p class="grid-heading" *ngIf="teamSeatsArr.length > 0">Your Team</p>
                <div class="floor-nofloorplan">
                    <ng-container *ngFor="let seat of teamSeatsArr; let i=index;">
                        <!-- TODO map seat selected color -->
                        <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                            <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                                <span class="rect-seat rect-seat-selected">
                                    {{seat.properties.name}}
                                </span>
                            </div>
                            <ng-template #selectable>
                                <div class="rectangle">
                                    <span class="rect-seat"
                                        [ngClass]="{'rect-seat-available': true }">
                                        {{seat.properties.name}}
                                    </span>
                                    <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                        src="assets/occupied-circle.svg" />
                                </div>
                            </ng-template>
                            <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id) "
                                [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                                [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-booked-employee-details>
                        </div>
                    </ng-container>
                </div>
                <p style="width: 100%;" *ngIf="teamSeatsArr.length === 0" >No seat available</p>
                <p class="grid-heading">Hot Seats</p>
                <div class="floor-nofloorplan" *ngIf="hotSeatsArr.length > 0">
                    <ng-container *ngFor="let seat of hotSeatsArr; let i=index;">
                        <!-- TODO map seat selected color -->
                        <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                            <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                                <span class="rect-seat rect-seat-selected">
                                    {{seat.properties.name}}
                                </span>
                            </div>
                            <ng-template #selectable>
                                <div class="rectangle">
                                    <span class="rect-seat"
                                        [ngClass]="{'hot-seat-available': seat.properties.status === 'AVAILABLE', 'hot-seat-na': seat.properties.status === 'Not Available', 'hot-seat-booked': seat.properties.status === 'BOOKED'}">
                                        {{seat.properties.name}}
                                    </span>
                                    <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                        src="assets/occupied-circle.svg" />
                                </div>
                            </ng-template>
                            <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.properties.ID) "
                                [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                                [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-booked-employee-details>
                            <app-searched-employee-details *ngIf="showSearchedEmployeeDetail && (showSearchedEmployee === seat.properties.ID)"
                                [initialZoom]="employeeDetailCardScale" [details]="searchedEmployeeBookings[0]"
                                [seatName]="layout.floorSeatsDTOMap[seat.id].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-searched-employee-details>
                        </div>
                    </ng-container>
                </div>
                <p *ngIf="hotSeatsArr.length === 0">Hot Seats are not available</p>
                <p class="grid-heading">Other Seats</p>
                <div class="floor-nofloorplan" *ngIf="otherSeatsArr.length > 0">
                    <ng-container *ngFor="let seat of otherSeatsArr; let i=index;">
                        <!-- TODO map seat selected color -->
                        <div class="seat-nofloorplan" id="{{seat.properties.ID}}" (click)="selectSeatOnGrid(seat)" title="{{seat.properties.name}}">
                            <div class="rectangle" *ngIf="selectedSeatOnGrid && (selectedSeatOnGrid.seatId === seat.properties.ID); else selectable">
                                <span class="rect-seat rect-seat-selected">
                                    {{seat.properties.name}}
                                </span>
                            </div>
                            <ng-template #selectable>
                                <div class="rectangle">
                                    <span class="rect-seat"
                                        [ngClass]="{'rect-seat-available': seat.properties.status === 'AVAILABLE', 'rect-seat-na': seat.properties.status === 'Not Available', 'rect-seat-booked': seat.properties.status === 'BOOKED'}">
                                        {{seat.properties.name}}
                                    </span>
                                    <img class="occupiedIcon" *ngIf="(seat.properties.status == 'SIGNED_IN')"
                                        src="assets/occupied-circle.svg" />
                                </div>
                            </ng-template>
                            <app-booked-employee-details *ngIf="showBookedEmployeeDetail && (showEmployeeDetail === seat.id)"
                                [details]="layout.floorSeatsDTOMap[showEmployeeDetail].seatBookedBydetails"
                                [seatName]="layout.floorSeatsDTOMap[showEmployeeDetail].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-booked-employee-details>
                            <app-searched-employee-details *ngIf="showSearchedEmployeeDetail && (showSearchedEmployee === seat.id)"
                                [initialZoom]="employeeDetailCardScale" [details]="searchedEmployeeBookings[0]"
                                [seatName]="layout.floorSeatsDTOMap[seat.id].seatName" [position]="'relative'"
                                (onClose)="closeEmployeeDetail($event)">
                            </app-searched-employee-details>
                        </div>
                    </ng-container>
                    <p *ngIf="otherSeatsArr.length === 0">No seats available</p>
                </div>
            </div>
            <div id="parking-view" *ngIf="view === 'parking-view'">
                <ng-container *ngFor="let section of gridParkingLayout">
                    <div class="tag-section" *ngIf="section.slots.length > 0">
                        <p class="tag-name">{{section.tagName}}</p>
                        <div class="slots-container">
                            <div class="scroll-wrapper" [ngStyle]="{
                                'width': gridParkingComputeScrollWrapperWidth(section.tagName, section.slots.length),
                                'flex-wrap': section.tagName === 'Available' ? 'wrap': 'nowrap'
                            }">
                                <div class="parking-slot-outer-container" [ngClass]="{
                                        'activeParkingSlot': (selectedSeatOnGrid.seatId === seat.properties.ID && selectedSeatOnGrid?.tag === seat.properties.tag) || checkIfBookedSlotIsPastBooking(seat),
                                        'activeParkingSlotPastBooking': checkIfBookedSlotIsPastBooking(seat)
                                    }" *ngFor="let seat of section.slots; let i=index;"
                                    (click)="selectSeatOnGrid(seat, seat.properties.tag)">
                                    <div class="parking-slot" [ngStyle]="{
                                                                        'border': (selectedSeatOnGrid?.seatId === seat.properties.ID && selectedSeatOnGrid?.tag === seat.properties.tag) || checkIfBookedSlotIsPastBooking(seat)? 'none': ''
                                                                    }">
                                        <p>{{seat.properties.name}}</p>
                                        <div class="svgContainer">
                                            <img *ngIf="getParkingSlotImageUrl(seat)" [src]="getParkingSlotImageUrl(seat)" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </section>
</div>
